module.exports = __webpack_public_path__ + "img/ic-gps-offline.3aabb3cd.svg";